import { call, put } from 'redux-saga/effects';

/**
 * Common Redux Saga try-catch pattern function
 * @param action
 * @param apiMethod
 * @param successAction
 * @param failedAction
 * @param payloadTransformer
 * @returns {Promise<*|{}>}
 */
export function* createSaga(action, apiMethod, successAction, failedAction, payloadTransformer = (p) => p) {
    try {
        const resp = yield call(apiMethod, payloadTransformer(action.payload));
        yield put(successAction(resp));
    } catch (e) {
        console.info(`API call failed in ${apiMethod.name}:`, e);
        yield put(failedAction(e));
    }
}
